// extracted by mini-css-extract-plugin
module.exports = {"textAreaBox":"formRemarks_textAreaBox__3vO-S","textAreaCount":"formRemarks_textAreaCount__YZfd5"};